import { render, staticRenderFns } from "./ContDataDashboard.vue?vue&type=template&id=26bee92e&lang=pug"
import script from "./ContDataDashboard.vue?vue&type=script&lang=js"
export * from "./ContDataDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26bee92e')) {
      api.createRecord('26bee92e', component.options)
    } else {
      api.reload('26bee92e', component.options)
    }
    module.hot.accept("./ContDataDashboard.vue?vue&type=template&id=26bee92e&lang=pug", function () {
      api.rerender('26bee92e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ContDataDashboard.vue"
export default component.exports